var map = {
	"./cs-cz.json": [
		"./src/assets/locales/cs-cz.json",
		[
			"src_assets_locales_cs-cz_json"
		]
	],
	"./da-dk.json": [
		"./src/assets/locales/da-dk.json",
		[
			"src_assets_locales_da-dk_json"
		]
	],
	"./de-de.json": [
		"./src/assets/locales/de-de.json",
		[
			"src_assets_locales_de-de_json"
		]
	],
	"./el-gr.json": [
		"./src/assets/locales/el-gr.json",
		[
			"src_assets_locales_el-gr_json"
		]
	],
	"./en-ar.json": [
		"./src/assets/locales/en-ar.json",
		[
			"src_assets_locales_en-ar_json"
		]
	],
	"./en-at.json": [
		"./src/assets/locales/en-at.json",
		[
			"src_assets_locales_en-at_json"
		]
	],
	"./en-au.json": [
		"./src/assets/locales/en-au.json",
		[
			"src_assets_locales_en-au_json"
		]
	],
	"./en-be.json": [
		"./src/assets/locales/en-be.json",
		[
			"src_assets_locales_en-be_json"
		]
	],
	"./en-ca.json": [
		"./src/assets/locales/en-ca.json",
		[
			"src_assets_locales_en-ca_json"
		]
	],
	"./en-ch.json": [
		"./src/assets/locales/en-ch.json",
		[
			"src_assets_locales_en-ch_json"
		]
	],
	"./en-co.json": [
		"./src/assets/locales/en-co.json",
		[
			"src_assets_locales_en-co_json"
		]
	],
	"./en-fi.json": [
		"./src/assets/locales/en-fi.json",
		[
			"src_assets_locales_en-fi_json"
		]
	],
	"./en-gb.json": [
		"./src/assets/locales/en-gb.json",
		[
			"src_assets_locales_en-gb_json"
		]
	],
	"./en-hk.json": [
		"./src/assets/locales/en-hk.json",
		[
			"src_assets_locales_en-hk_json"
		]
	],
	"./en-id.json": [
		"./src/assets/locales/en-id.json",
		[
			"src_assets_locales_en-id_json"
		]
	],
	"./en-ie.json": [
		"./src/assets/locales/en-ie.json",
		[
			"src_assets_locales_en-ie_json"
		]
	],
	"./en-in.json": [
		"./src/assets/locales/en-in.json",
		[
			"src_assets_locales_en-in_json"
		]
	],
	"./en-kr.json": [
		"./src/assets/locales/en-kr.json",
		[
			"src_assets_locales_en-kr_json"
		]
	],
	"./en-my.json": [
		"./src/assets/locales/en-my.json",
		[
			"src_assets_locales_en-my_json"
		]
	],
	"./en-nz.json": [
		"./src/assets/locales/en-nz.json",
		[
			"src_assets_locales_en-nz_json"
		]
	],
	"./en-th.json": [
		"./src/assets/locales/en-th.json",
		[
			"src_assets_locales_en-th_json"
		]
	],
	"./en-tw.json": [
		"./src/assets/locales/en-tw.json",
		[
			"src_assets_locales_en-tw_json"
		]
	],
	"./en-us.json": [
		"./src/assets/locales/en-us.json",
		[]
	],
	"./en-za.json": [
		"./src/assets/locales/en-za.json",
		[
			"src_assets_locales_en-za_json"
		]
	],
	"./es-es.json": [
		"./src/assets/locales/es-es.json",
		[
			"src_assets_locales_es-es_json"
		]
	],
	"./es-mx.json": [
		"./src/assets/locales/es-mx.json",
		[
			"src_assets_locales_es-mx_json"
		]
	],
	"./es-us.json": [
		"./src/assets/locales/es-us.json",
		[
			"src_assets_locales_es-us_json"
		]
	],
	"./fr-ca.json": [
		"./src/assets/locales/fr-ca.json",
		[
			"src_assets_locales_fr-ca_json"
		]
	],
	"./fr-fr.json": [
		"./src/assets/locales/fr-fr.json",
		[
			"src_assets_locales_fr-fr_json"
		]
	],
	"./hu-hu.json": [
		"./src/assets/locales/hu-hu.json",
		[
			"src_assets_locales_hu-hu_json"
		]
	],
	"./it-it.json": [
		"./src/assets/locales/it-it.json",
		[
			"src_assets_locales_it-it_json"
		]
	],
	"./ja-jp.json": [
		"./src/assets/locales/ja-jp.json",
		[
			"src_assets_locales_ja-jp_json"
		]
	],
	"./nb-no.json": [
		"./src/assets/locales/nb-no.json",
		[
			"src_assets_locales_nb-no_json"
		]
	],
	"./nl-nl.json": [
		"./src/assets/locales/nl-nl.json",
		[
			"src_assets_locales_nl-nl_json"
		]
	],
	"./pl-pl.json": [
		"./src/assets/locales/pl-pl.json",
		[
			"src_assets_locales_pl-pl_json"
		]
	],
	"./pt-br.json": [
		"./src/assets/locales/pt-br.json",
		[
			"src_assets_locales_pt-br_json"
		]
	],
	"./pt-pt.json": [
		"./src/assets/locales/pt-pt.json",
		[
			"src_assets_locales_pt-pt_json"
		]
	],
	"./sv-se.json": [
		"./src/assets/locales/sv-se.json",
		[
			"src_assets_locales_sv-se_json"
		]
	],
	"./tr-tr.json": [
		"./src/assets/locales/tr-tr.json",
		[
			"src_assets_locales_tr-tr_json"
		]
	],
	"./zh-cn.json": [
		"./src/assets/locales/zh-cn.json",
		[
			"src_assets_locales_zh-cn_json"
		]
	],
	"./zh-hk.json": [
		"./src/assets/locales/zh-hk.json",
		[
			"src_assets_locales_zh-hk_json"
		]
	],
	"./zh-sg.json": [
		"./src/assets/locales/zh-sg.json",
		[
			"src_assets_locales_zh-sg_json"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__.t(id, 3 | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = "./src/assets/locales lazy recursive ^\\.\\/.*\\.json$ referencedExports: default";
module.exports = webpackAsyncContext;